import { BlogPost } from './types';
import { snowboardsPosts } from './snowboardsPosts';
import { skisPosts } from './skisPosts';
import { surfboardsPosts } from './surfboardsPosts';
import { mountainBikesPosts } from './mountainBikesPosts';
import { gearReviewsPosts } from './gearReviewsPosts';
import { storiesThatStokePosts } from './storiesThatStokePosts';

export type { BlogPost };

// Static blog posts - these will be combined with database posts
export const blogPosts: BlogPost[] = [
  ...surfboardsPosts,
  ...snowboardsPosts,
  ...skisPosts,
  ...mountainBikesPosts,
  ...gearReviewsPosts,
  ...storiesThatStokePosts,
].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
